import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { useState } from "react";
import Image from "next/image";
import { useTranslation } from "react-i18next";

export function VerifiedComponent() {
  const [redirectTimer, setRedirectTimer] = useState(false);

  const { config, getImagePath } = useClientConfigProvider();
  const { t } = useTranslation();
  return (
    <div
      className="login-label"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        alignItems: "center",
        fontSize: "20px",
        marginBlock: "10px",
      }}
    >
      <Image
        src={getImagePath("success.gif")}
        alt=""
        width="200"
        height="200"
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",

          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="otp-verified">{t("common.signInSuccess")}</div>

        {/* <div className="redirection-text">
          <p className="">Don't close this window.</p>
          <p className="">
            You will be redirected in{" "}
            <span className="redirection-timer">5 sec</span>
          </p>
        </div> */}
      </div>
    </div>
  );
}
